import script from "./InternetTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./InternetTemplate.vue?vue&type=script&setup=true&lang=js"

import "./InternetTemplate.vue?vue&type=style&index=0&id=34f64256&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34f64256"]])

export default __exports__